import { post, get } from '../axios'

export const login = p => post(`/members-api/loginController/platform`, p);


export const getChannelSellerInfo = p => post(`/members-api/common/getChannelSellerInfo`, p);

export const getMenus = p => get(`/members-api/platform/menu-version/menus`, p);
